import { Input } from "../../ui/input";

export function EINField({
  item,
  value,
  error,
  helperText,
  disabled,
  onChange,
  className,
}) {
    const formatEIN = (value) => {
    if (!value) return ""
    const cleaned = value.replace(/\D/g, "")
    const match = cleaned.match(/^(\d{0,2})(\d{0,7})$/)
    if (match) {
      return [match[1], match[2]].filter(Boolean).join("-")
    }
    return value
  }

  const handleChange = (e) => {
    const input = e.target.value;
    const cleaned = input.replace(/\D/g, "");
    onChange({ target: { value: cleaned } });
  };

  return (
    <Input
      type="text"
      placeholder={item.placeholder || "12-3456789"}
      value={formatEIN(value || "")}
      onChange={handleChange}
      disabled={disabled}
      className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500" : "border-gray-300"} ${
        className || ""
      }`}
      maxLength={10}
    />
  );
}
